
import { Checkbox } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectStatusFilter } from "../../redux/selector";
import { adminManagementSlice } from "../../redux/slice";
import { statusFilter } from "../../types";
import { useStyles } from "./styles";
import { AddButton } from "../../../../components/Button/AddButton"
import { FilterSelect } from "../../../../components/FilterSelect"
import { STATUS_OPTIONS } from "../../types"
import { CheckboxIcon, CheckboxOutlineIcon } from "app/icons";



type Props = {
  onAddClick?: () => void;
};

const CHECKBOX_SIZE = 18;
const checkboxControl = {
  disableRipple: true,
  icon: <CheckboxOutlineIcon width={CHECKBOX_SIZE} height={CHECKBOX_SIZE} />,
  checkedIcon: <CheckboxIcon width={CHECKBOX_SIZE} height={CHECKBOX_SIZE} />,
  sx: { p: 0, width: CHECKBOX_SIZE, height: CHECKBOX_SIZE },
};

export const ActionBar = ({ onAddClick }: Props) => {

    const { t } = useTranslation();
    const styles = useStyles();
    const dispatch = useDispatch();
    const statusFilter = useSelector(selectStatusFilter);

    const handleStatusChange = (value: statusFilter) => {
          dispatch(adminManagementSlice.actions.setStatusFilter(value))
      } 

    
    const getStatusLabel = (value: statusFilter) =>
        t(
          value === "ALL"
            ? "ADMIN_MANAGEMENT.STATUS_ALL"
            : `ADMIN_MANAGEMENT.STATUS_VALUES.${value.toUpperCase()}`
        ); 

    const renderOptionContent = (option: statusFilter, isSelected: boolean) => {
        let badge: React.ReactNode;
        if (option === "active") {
          badge = <span className={styles.activeBadge}>{getStatusLabel(option)}</span>;
        } else if (option === "not_active") {
          badge = <span className={styles.inactiveBadge}>{getStatusLabel(option)}</span>;
        } else {
          badge = <span className={styles.optionLabel}>{getStatusLabel(option)}</span>;
        }
        return (
          <div className={styles.optionRow}>
            <Checkbox {...checkboxControl} checked={isSelected} className={styles.optionCheckbox} />
            {badge}
          </div>
        );
    };

    
  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton 
        label={t("USER_MANAGEMENT.ADD")}
        onClick={onAddClick}/>
      </div>
      <FilterSelect 
          label={t("ADMIN_MANAGEMENT.TABLE.STATUS")}
          value={statusFilter}
          options={STATUS_OPTIONS}
          getOptionLabel={(value) => getStatusLabel(value)}
          renderOption={renderOptionContent}
          onChange={handleStatusChange}/>
    </div>
  );
};
    
